import {  useState, useEffect } from "react";
import Email from "../ProfileImages/Email.svg";
import { Modal } from "../../Screens/Modal/Modal";
import styles from "../../../Components/Dashboard/DashboardComponents/TransferComponent/transfer.module.css";
import { useContext } from "react";
import { ContextProvider } from "../../Context";
import PopUpGreen from "../ProfileImages/PopUpGreen.svg";
import PopUpGreenTab from "../ProfileImages/PopUpGreenTab.svg";
import PopUpGreenDeskTop from "../ProfileImages/PopUpGreenDeskTop.svg";
import OtpInput from "react-otp-input";
import { AiFillEyeInvisible } from "react-icons/ai";
import { AiFillEye } from "react-icons/ai";
import Cancel from "../ProfileImages/Cancel.svg";
import ChangePassword from "./ChangePassword";
import Success from "../ProfileImages/success.gif";
import axios from "axios";
import { BASE_URL } from "../../../config";
import { Loader } from "../../Loader/Loader";
import { GetLocalStorage, } from "../../LocalStorage/LocalStorage";
import { PostFunction } from "../../ApiCollection.jsx/ApiBuck";
import { PutFunction } from "../../ApiCollection.jsx/ApiBuck";

const ChangePin = (Data) => {
  const { toggleSideBar, isDarkMode, customerDetail, state, networkIssue, setNetworkIssue, sessionModal, setSessionModal } = useContext(ContextProvider);
  const [loading, setLoading] =useState(false);
  const [activeBtn, setActiveBtn] = useState([true, false, false]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [changePin, setChangePin] = useState(true);
const {email} = customerDetail;
  const handleClick = (index) => {
    setActiveBtn(activeBtn.map((_, i) => i === index));
    setActiveIndex(index);
    setChangePin(index === 0);
  };

  const handlePinInput = (value, setter) => {
    const numericValue = value.replace(/\D/g, "");
    const truncatedValue = numericValue.slice(0, 4);
    setter(truncatedValue);
  };

  const [newPin, setNewPin] = useState("");
  const [oldPin, setOldPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [update, setUpdate] = useState("");
 

  const [resetPin, setResetPin] = useState("");

  const {
    isVisible,
    toggleVisibility,
    //inputPinHandler,
    inputPin,
    setInputPin,
  } = useContext(ContextProvider);
Data = GetLocalStorage();
  const { emailId, setEmailId } = useContext(ContextProvider);
  const [emailInputColor, setEmailInputColor] = useState("");
 // const [pin, setPin] = useState("");
  const [confirmResetPin, setConfirmResetPin] = useState("");
  const [resetPinErrorMessage, setResetPinErrorMessage] = useState("");
  const [resetPinUpdate, setResetPinUpdate] = useState("");
  const [verify, setVerify] = useState("");
  const [newResetPin, setNewResetPin] = useState("");
  const [errorVerifyOtp, setErrorVerifyOtp] = useState(false)
  const [errorCreateNewPin, setErrorCreateNewPin] = useState("")

  const [countdown, setCountdown] = useState(60);
  const [resendActive, setResendActive] = useState(false);

const [resetPin1, setResetPin1] = useState(false);
  const [createPin, setCreatePin] = useState("");
  const [confirmPinInputBgColor, setConfirmPinInputBgColor] = useState("");
// const [verifyResponse, setVerifyResponse] = useState({})
//   const [resetResponse, setResetResponse] = useState({})


// An Api to help change the user's pin
const ChangeUserPin = async()=> {
  const usernameToken= localStorage.getItem("xcss{}");
  const emailToken  = localStorage.getItem("xcss[]");
  if(!navigator.onLine) return alert("Check your internet connection")
  if(usernameToken || emailToken ){
    setLoading(true)
  try{
  const data ={
    "old_pin" : oldPin,
    "new_pin" : newPin
   }
   const dataJson = JSON.stringify(data);
   const url = `${BASE_URL}/pin`;
   const response = await axios.patch(url,dataJson,
    {headers : {"Content-Type":"application/json" }, 
    withCredentials : true
  })
   if(response.status === 200 || response.status === 201){
    setUpdate(true);
   }

   }catch(error){

     if(error && (error.response.status === 400  )){
      alert("Invalid Old Pin")
     }else if(error && (error.response.status === 401  )){
      
       
    }else if(error && error.response.status === 404){
     if(networkIssue) return;
      if(!networkIssue) return setNetworkIssue(true)
     }else if(error && error.response.status === 500){
      alert("SERVER ERROR")
     }else {
     return;
     }
   }finally{
    setLoading(false)
   }
  }}

  const handleUpdate = async() => {
    if(!oldPin || !newPin || !confirmPin){
setErrorMessage("Please fill in all fields");
    }else if(oldPin.length < 4 || newPin.length < 4 || confirmPin.length < 4){
setErrorMessage("Pin digits for old,new and Confirm input must be 4 digits long")
    }else if (newPin !== confirmPin) {
      setErrorMessage("PIN does not match...");
      document.getElementById("confirmPinInput").style.backgroundColor =
        "#FFD8D8";
    } else {
      setErrorMessage("");
      document.getElementById("confirmPinInput").style.backgroundColor = "";
      await ChangeUserPin()
   }
  };

// Funcytion to help set user Email
  const ResetFunction = async()=> {
    const SuccessHandler = ()=> {
      alert("An Otp has been sent to you")
       setResetPinUpdate(true);
       setCountdown(60);
    }
    const FailedHandler = ()=> {
      alert("The Otp failed to sent");
    }
    let path = "send-otp/resetpin"
    const body = {
      email : Data.UserEmail
    }

await PostFunction(path, setLoading, body, SuccessHandler, FailedHandler,()=> {}, setNetworkIssue );
  }

  const handleResetPinUpdate = async() => {
    if (state.email === undefined && email === undefined  && Data.UserEmail === undefined) {
        setResetPinErrorMessage("No email..");
      setEmailInputColor("#F95252");
      setResetPinUpdate(false);
    } else {
    setResetPinErrorMessage(false);
      setEmailInputColor("#2ED173");
      if(!navigator.onLine) {
   if(networkIssue) return;
      if(!networkIssue) return setNetworkIssue(true)
      }
      if(navigator.onLine){
   await ResetFunction();
      }
    }
  };
  

  const VerifyFunction = async()=> {
    const SuccessHandler = ()=> {
   setResetPinUpdate(false)
   setVerify(true);
   setInputPin("");
  }
    const FailedHandler = ()=> {
      setErrorVerifyOtp(true);
      setInputPin("")
    }
    let path = `verify-otp/resetpin?email=${Data.UserEmail}`
    const body = {
      otp : inputPin
    }

await PostFunction(path, 
  setLoading, 
  body,
   SuccessHandler, 
   FailedHandler, 
  ()=>{}, setNetworkIssue);
  }


   const PutNewFunction = async()=> {
    const SuccessHandler = ()=> {
  
    setCreatePin(true);
    setErrorCreateNewPin("");
}
    const FailedHandler = async(ErrorType)=> {
       setErrorCreateNewPin("Request to reset pin failed");
       if(ErrorType === "unauthorised"){
        setSessionModal(true)
       }else if(ErrorType === "Server error"){
       alert("An Unexpected error has occured")
       }else if(ErrorType === "Network error" || ErrorType === "User error"){
       if(networkIssue) return;
      if(!networkIssue) return setNetworkIssue(true)
       }else{
        alert("An unexpected error has occured");
       }
}
    let path = "pin/reset"
    const body = {
      pin : newResetPin
    }

await PutFunction(path, setLoading, body, SuccessHandler, FailedHandler, setNetworkIssue);
  }

  const handleCreatePin = async() => {
    if(newResetPin !== confirmResetPin){
    
      setConfirmPinInputBgColor("#FFD8D8");
       setErrorCreateNewPin("PIN does not match...")
    } else {
      setConfirmPinInputBgColor("");
       setErrorCreateNewPin("Pin Okay");
     if(!navigator.onLine) return alert("Check your internet connection");
      if(navigator.onLine){
      await PutNewFunction();
      }
    }
  };


  useEffect(() => {
    let timer;

    const decrementCountdown = () => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    };

    timer = setInterval(() => {
      decrementCountdown();
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const handleResendOTP = async() => {
    await ResetFunction();
    setCountdown(60);
    setResendActive(false);
  };
  useEffect(() => {
    if (countdown === 0) {
      setResendActive(true);
    }
  }, [countdown]);


  const [changePassword, setChangePassword] = useState("");
  const { authenticationOpen } = useContext(ContextProvider);
  return (
    <div>
      {authenticationOpen && (
        <div
          className={`relative lg:ml-[20px] 2xl:ml-0 ${
            isDarkMode
              ? // ? "bg-white text-[#fff] border-[#fff]"
                "bg-black border-[#fff]"
              : "bg-[#ffffff] text-[#000] "
          } flex flex-col justify-between h-full`}
        >
          <section>
            <div className="flex items-center my-[10%] gap-[8px] md:my-[5%] md:text-[18px] lg:text-[px]">
              <p
                className={`text-[#7c7c7c] text-[12px] leading-[130%] md:text-[14px] lg:text-[18px] 2xl:text-[28px] ${
                  isDarkMode ? "text-white" : ""
                }`}
              >
                Secure Your Account Privacy
              </p>
              <img
                src={Email}
                alt=""
                className="w-[12px] h-[12px] md:w-[14.083px] md:h-[14.083px] lg:w-[24px] lg:h-[24px]"
              />
            </div>
              <div className="text-[12px] flex  md:text-[18px] 
            lg:text-[20px] justify-between md:justify-between md:gap-[5%]">
              <div
                onClick={() => {
                  handleClick(0);
                  setChangePin(true);
                  setResetPin(false);
                  setChangePassword(false);
                  setResetPin1(false);
                  setErrorMessage("");
                  setResetPinErrorMessage("");
                  setOldPin("");
                  setNewPin("");
                  setConfirmPin("");
                }}
                className={`${
                  activeBtn[0]
                    ? `bg-[#E2F3FF] rounded-[4px] border-b-[2px]  border-b-[#04177f] h-[25px] flex items-center  justify-center py-[10px] md:h-[35px] lg:rounded-[6px] lg:border-b-[4px] lg:h-[60px] ${
                        isDarkMode ? "text-black" : ""
                      }`
                    : ""
                } cursor-pointer w-[144px] justify-center rounded-[2px] md:w-[180px] md:rounded-[3px] md:justify-center md:items-center flex lg:w-[248px] lg:rounded-[6px] 2xl:text-[24px]`}
              >
              <p className="md:text-[10px] md:leading-[14px]
               font-[400] lg:text-[14px] lg:leading-[20px] ">
                  Change Pin
                  </p>
              </div>
              <div
                onClick={() => {
                  handleClick(1);
                  setChangePin(false);
                  setResetPin(true);
                  setChangePassword(false);
                  setErrorMessage("");
                  setResetPinErrorMessage("");
                  setConfirmResetPin("");
                  setNewResetPin("");
                  setEmailId("");
                //  setPin("");
                  setEmailInputColor("");
                }}
                className={`${
                  activeBtn[1]
                    ? `bg-[#E2F3FF] rounded-[4px] border-b-[2px] border-b-[#04177f] h-[25px] flex items-center justify-center py-[10px] md:h-[35px] lg:rounded-[6px] lg:border-b-[4px] lg:h-[60px] ${
                        isDarkMode ? "text-black" : ""
                      }`
                    : ""
                } cursor-pointer w-[144px] justify-center rounded-[2px] md:w-[180px] md:rounded-[3px] md:justify-center md:items-center flex lg:w-[248px] lg:rounded-[6px] 2xl:text-[24px]`}
              >
               <p className="md:text-[10px] md:leading-[14px] font-[400] lg:text-[14px] lg:leading-[20px] ">
               Reset Pin
                  </p>
              </div>

              <div
                onClick={() => {
                  handleClick(2);
                  setChangePin(false);
                  setResetPin(false);
                  setChangePassword(true);
                  setResetPin1(false);
                  setErrorMessage("");
                  setResetPinErrorMessage("");
                }}
                className={`${
                  activeBtn[2]
                    ? `bg-[#E2F3FF] rounded-[4px] border-b-[2px] border-b-[#04177f] h-[25px] flex justify-center items-center py-[10px] md:h-[35px] lg:rounded-[6px] lg:border-b-[4px] lg:h-[60px] ${
                        isDarkMode ? "text-black" : ""
                      }`
                    : ""
                } cursor-pointer w-[148px] justify-center rounded-[2px] md:w-[180px] md:rounded-[3px] md:justify-center md:items-center flex lg:w-[248px] lg:rounded-[6px] 2xl:text-[24px]`}
              >
                {/* w-[144px] */}
                <p className="md:text-[10px] md:leading-[14px] font-[400] lg:text-[14px] lg:leading-[20px] ">
                  Change Password
                  </p>
              
              </div>
            </div>
            <hr />

            {changePin && (
              <div>
                {/* <div className="grid grid-cols-1 mt-[10px] md:grid-cols-2 gap-y-[10px] md:gap-x-6 lg:gap-x-6 md:gap-y-[0px] lg:gap-y-[25px] pb-[30px] lg:py-[30px] md:mt-[20px]"> */}
                <div className="flex flex-col mt-[10px] lg:gap-[25px] gap-[20px] w-full pb-[30px] lg:py-[30px] md:mt-[20px]">
                  <div className="flex flex-col sm:items-center md:flex-row lg:gap-[22px] gap-[20px] w-full">
                    {/* <div className="mt-[30px] w-1/2 md:w-full "> */}
                    <div className="flex flex-col md:w-[50%] w-full md:gap-[10px] gap-2.5 ">
                      <h2
                        className={`text-[13px] font-semibold md:text-[14px] lg:text-[18px] mt-2 md:mt-0 ${
                          isDarkMode ? "text-white" : "black"
                        }`}
                      >
                        Old PIN
                      </h2>
                      {/* <div className="relative mt-[5px] lg:mt-[0px]"> */}
                      <div className="relative">
                        <input 
                        onInput={(e)=> {
                         const value = e.target.value;
                         const numericValue = value.replace(/\D/g, "");
                         e.target.value = numericValue
                        }}
                          type="tel"
                        className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                          placeholder="Your Old pin"
                          maxLength={4}
                          value={oldPin}
                          onChange={(event) =>
                            handlePinInput(event.target.value, setOldPin)
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="mt-[30px] md:ml-[-20px] lg:ml-[-50px] w-1/2 md:w-full "> */}
                    <div className="flex flex-col md:w-1/2 w-full md:gap-[10px] gap-2.5 ">
                      <h2
                        className={`text-[13px] text-[#7E7E7E] font-semibold md:text-[14px] lg:text-[18px] ${
                          isDarkMode ? "text-white" : "text-black"
                        }`}
                      >
                        New PIN
                      </h2>
                      <div className="relative ">
                        <input
                           onInput={(e)=> {
                         const value = e.target.value;
                         const numericValue = value.replace(/\D/g, "");
                         e.target.value = numericValue
                        }}
                          type="tel"
                          className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                          placeholder="Your New Pin"
                          maxLength={4}
                          value={newPin}
                          onChange={(event) =>
                            handlePinInput(event.target.value, setNewPin)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col md:w-1/2 w-full md:gap-[10px] gap-2.5">
                    <h2
                      className={`text-[13px] font-semibold md:text-[14px] lg:text-[18px] mt-2 md:mt-0 ${
                        isDarkMode ? "text-white" : "text-black"
                      }`}
                    >
                      Confirm PIN
                    </h2>
                    <div className="relative">
                      <input
                         onInput={(e)=> {
                         const value = e.target.value;
                         const numericValue = value.replace(/\D/g, "");
                         e.target.value = numericValue
                        }}
                        id="confirmPinInput"
                        type="tel"
                        className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                        placeholder="Inputs to confirm your new pin"
                        maxLength ={4}
                        value={confirmPin}
                        onChange={(event) =>
                          handlePinInput(event.target.value, setConfirmPin)
                        }
                      />
                    </div>

                   
                  </div>
                  {errorMessage && (
                      <p className="text-red-500 text-start text-[10px] mt-[5px]">
                        {errorMessage}
                      </p>
                    )}
                </div>

                <div className="py-[30px] lg:py-[60px]">
                  <button
                    className={`${
                      !oldPin || !newPin || !confirmPin
                        ? "bg-[#63616188] cursor-not-allowed"
                        : "bg-primary"
                    } w-full md:w-fit text-white rounded-md px-[28px] text-[12px] md:px-[30px] md:py-[10px] md:text-[13px] md:font-[600] leading-[15px] lg:text-[16px] lg:px-[60px] lg:py-[15px] 2xl:text-[20px] 2xl:px-[50px] 2xl:py-[10px] lg:leading-[24px] py-[15px]
              `}
                    onClick={handleUpdate}
                    disabled={!oldPin || !newPin || !confirmPin}
                  >
                    Update
                  </button>
                </div>
              </div>
            )}

            {update && (
              <Modal className="">
                <div
                  className={` ${
                    toggleSideBar ? "absolute overflow-y-auto w-[90%] h-[270px] md:w-[45%] lg:w-[40%] md:h-[350px] md:ml-[20%]  lg:h-[405px] shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)] top-[0%]" : " absolute overflow-y-auto w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] h-[300px] lg:h-[405px]  shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)]"
                  } flex flex-col justify-between items-center pb-[10px] md:pb-[30px] lg:pb-[30px] md:mx-auto md:my-auto rounded-[12px] ${isDarkMode ? "bg-stone-950 border-white border": "bg-white"}`}
                >
                  <div className="absolute z-0 right-0" style={{ zIndex: 0 }}>
                    <img
                      src={PopUpGreen}
                      alt=""
                      className="md:hidden rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenTab}
                      alt=""
                      className="hidden md:block rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenDeskTop}
                      alt=""
                      className="hidden rounded-tr-[20px]"
                    />
                  </div>

                  <div className="relative z-10">
                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[8%] lg:mt-[3%] z-[1000] ${styles.overlayText}`}
                    >
                      Successful
                    </p>

                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[4%] lg:my-[%] z-[1000] ${styles.overlayText}`}
                    >
                      You have successfully changed your transaction PIN.
                    </p>
                  </div>

                  <img src={Success} alt="" className="h-[50%] md:h-[40%]" />

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setUpdate(false);
                      setOldPin("");
                      setNewPin("");
                      setConfirmPin("");
                      handleClick(activeIndex);
                    }}
                    className={`my-[%] py-[10px] md:py-[12px] mt-0  bg-[#04177f] w-[90%] 
                      flex justify-center items-center mx-auto cursor-pointer text-[12px] font-extrabold h-[40px] text-white rounded-[6px] md:w-[40%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
                  >
                    Done
                  </button>
                </div>
              </Modal>
            )}

            {resetPin && (
              <div
                className={` relative lg:ml-[20px] 2xl:ml-0 ${
                  isDarkMode
                    ? "bg-[#000] text-[#fff] border-[#fff]"
                    : "bg-[#ffffff] text-[#000] "
                } flex flex-col justify-between h-full`}
              >
                <section className="">
                  <div className="mt-[30px] flex flex-col md:w-[50%] w-full md:gap-[10px] gap-2.5">
                    <h2
                      className={`text-[13px]  font-semibold md:text-[14px] lg:text-[18px]  ${
                        isDarkMode ? "text-white" : "text-black"
                      }`}
                    >
                       Email
                    </h2>
                    <div className="relative ">
                      <input
                        type="text"
                        readOnly
                         className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                      
                        value={
                          !email && state.email.length > 1
                            ? state.email
                            : email
                            ? email
                            : Data.UserEmail
                            ? Data.UserEmail
                            : "No email"
                        }
                        style={{ borderColor: emailInputColor }}
                        onChange={(event) => {
                          setEmailId(event.target.value);
                          setEmailInputColor("");
                        }}
                      />
                    </div>

                    {resetPinErrorMessage && (
                      <p className="text-red-500 text-start text-[10px] mt-[5px]">
                        {resetPinErrorMessage}
                      </p>
                    )}
                  </div>

                  <div className="mt-[10%] md:mt-[5%] flex flex-col md:w-[50%] w-full md:gap-[10px] gap-2.5">
                  
                   
                  </div>

                  <div className="py-[30px] lg:py-[60px]">
                    <button
                      className={`${
                        (state.email === undefined && email === undefined && Data.UserEmail === undefined) ?
                           "bg-[#63616188] cursor-not-allowed"
                          : "bg-primary"
                      } w-full md:w-fit text-white rounded-md px-[28px] text-[12px] md:px-[30px] md:py-[10px] md:text-[13px] md:font-[600] leading-[15px] lg:text-[16px] lg:px-[60px] lg:py-[15px] 2xl:text-[20px] 2xl:px-[50px] 2xl:py-[10px] lg:leading-[24px] py-[15px]
                    `}
                      disabled={state.email === undefined && email === undefined && Data.UserEmail === undefined}
                      onClick={() => {
                        handleResetPinUpdate();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </section>
              </div>
            )}

            {resetPinUpdate && (
              <Modal>
              <div
              // confirm02
                  className={`flex flex-col items-center justify-center px-[20px] pb-[20px]  ${
                    toggleSideBar ? "w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] md:ml-[20%] h-auto lg:h-[405px] shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)]  " : " w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] h-auto lg:h-[405px]  shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)]"} 
                    md:mx-auto md:my-auto lg:mx-auto lg:my-auto rounded-[12px] ${isDarkMode ? "bg-stone-950 border-white border" : "bg-white"} `}
                >
                  <img
                    onClick={() => setResetPinUpdate(false)}
                    className="absolute cursor-pointer right-2 w-[18px] h-[18px] my-[1%] md:w-[35px] md:h-[25px] lg:w-[45px] lg:h-[45px] "
                    src={Cancel}
                    alt=""
                  />

                  <hr className="h-[6px] bg-[#04177f] lg:mt-[10%] border-none mt-[8%] md:mt-[7%] md:h-[10px]" />
                  <p className="md:mt-[15%] lg:mt-[10%] text-[12px] px-[20px] md:text-[14px] lg:text-[18px] font-extrabold text-center my-[5%] lg:my-[%]">
                    Verification code has been sent to your email - {emailId || Data.UserEmail}
                  </p>
                  <div className="flex flex-col gap-[10px] justify-center items-center font-extrabold mb-[7%]">
                    <div className={`flex justify-center items-center
                       ml-[5%] gap-[10px] md:ml-[5%] md:gap-[30px] ${!isVisible ? "flex gap-[1px] ml-[0px] " : "flex justify-center items-center ml-[5%] gap-[10px] md:ml-[5%] md:gap-[30px]"}`}>
                      {isVisible ? (
                        <OtpInput
                          value={inputPin}
                          inputType="tel"
                          onChange={setInputPin}
                          numInputs={6}
                          shouldAutoFocus={true}
                          inputStyle={{
                            color: isDarkMode ? "#ffffff" : "#403f3f",
                            width: 30,
                            height: 30,
                            borderRadius: 3,
                            backgroundColor: isDarkMode ? "black" : "white",
                          border: isDarkMode
                            ? "1px solid white"
                            : "1px solid #ccc",
                          }}
                          renderInput={(props) => (
                            <input {...props} className="inputOTP mx-[3px] text-base" />
                          )}
                        />
                      ) : (
                        <div className="text-[24px] md:text-[24px] mt-1">
                          * * * * * *
                        </div>
                      )}
                      <div
                        className="text-[#0003] text-xl md:text-3xl"
                        onClick={toggleVisibility}
                      >
                        {isVisible ? <AiFillEye className={`${isDarkMode ? "text-white" : ""}`} /> : <AiFillEyeInvisible className={`${isDarkMode ? "text-white" : ""}`} />}
                      </div>
                    </div>
                    <div className={`flex justify-between w-full `}>
                      <p className={` text-[12px] md:text-[12px] text-[#04177f] ${isDarkMode ? "text-white" : ""}`}>{countdown > 0 ? `${countdown}sec` : "0sec"}</p>
                      <p className={` text-[12px] md:text-[12px] text-[#04177f] ${isDarkMode ? "text-white" : ""}`}
                        onClick={() => {
                          if (resendActive) {
                            handleResendOTP();
                          }
                        }}
                        style={{
                          cursor: resendActive ? "pointer" : "not-allowed",
                          color: isDarkMode ? "#fff" :
                            resendActive ? "#04177f"  : "#808080",
                        }}
                      >
                        Resend OTP
                      </p>
                    </div>
                    {errorVerifyOtp && (
                      <p className="text-center text-red-500 text-[14px] font-[400] leading-[20px]">
                        Incorrect Pin
                      </p>
                    )}
                  </div>

                  <button
                    onClick={(e) => {
                   VerifyFunction();
                    }}
                    disabled={inputPin.length !== 6}
                    className={` py-[16px] ${
                      inputPin.length !== 6 ? `bg-[#0008] cursor-not-allowed ${isDarkMode ? "bg-stone-400 cursor-not-allowed": ""}` : "bg-[#04177f] cursor-pointer"
                    } w-full text-[12px] leading-[16px] md:leading-[20px]  font-extrabold text-white rounded-[6px] md:w-[40%] md:rounded-[8px] md:text-[16px] lg:w-[163px]  lg:my-[2%]`}
                  >
                    Verify
                  </button>
                </div>
              </Modal>
            )}

            {verify && (
              <Modal className="">
                <div
                  className={` flex flex-col justify-center items-center ${
                    toggleSideBar ? "w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] md:ml-[20%] h-[250px] lg:h-[405px] shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)] " : " w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] h-[250px] lg:h-[405px]  shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)]"
                    }  pb-[10px] md:pb-[30px] lg:pb-[30px] md:mx-auto md:my-auto lg:mx-auto lg:my-auto rounded-[12px] ${isDarkMode ? "bg-stone-950 border-white border": "bg-white"}`}
                >
                  <div className="absolute z-0 right-0" style={{ zIndex: 0 }}>
                    <img
                      src={PopUpGreen}
                      alt=""
                      className="md:hidden rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenTab}
                      alt=""
                      className="hidden md:block rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenDeskTop}
                      alt=""
                      className="hidden rounded-tr-[20px]"
                    />
                  </div>

                  <div className="relative z-10">
                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[8%] lg:mt-[3%] z-[1000] ${styles.overlayText}`}
                    >
                      Successful
                    </p>

                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[4%] lg:my-[%] z-[1000] ${styles.overlayText}`}
                    >
                      Verification Successful
                    </p>
                  </div>

                  <img src={Success} alt="" className="h-[50%] md:h-[40%]" />

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setVerify(false);
                      setEmailId("");
                      setEmailInputColor("");
                    //  setPin("");
                      setResetPin(false);
                      setResetPin1(true);
                    }}
                    className={`my-[%] mt-0 bg-[#04177f] w-[90%] flex justify-center items-center mx-auto cursor-pointer text-[12px] font-extrabold h-[40px] text-white rounded-[6px] md:w-[40%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
                  >
                    Create New Pin
                  </button>
                </div>
              </Modal>
            )}

            {resetPin1 && (
              <div
                className={`relative lg:ml-[20px] 2xl:ml-0 ${
                  isDarkMode
                    ? "bg-[#000] text-[#fff] border-[#fff]"
                    : "bg-[#ffffff] text-[#000] "
                } flex flex-col justify-between h-full`}
              >
                <section className="">
                  <div className="mt-[30px]">
                    <h2 className={`text-[12px] text-[#04177F] font-semibold md:text-[14px] lg:text-[18px] text-center md:text-start ${isDarkMode? "text-white" : ""}`}>
                      Create New Transaction PIN to Continue Operations!
                    </h2>
                  </div>

                  <div className="mt-[10%] lg:mt-[3%]">
                    <h2 className={`text-[12px] text-[#7E7E7E] font-semibold md:text-[14px] lg:text-[18px] ${isDarkMode ? "text-white" : ""}`}>
                      Input PIN
                    </h2>
                    <div className="mt-[3%]">
                      <OtpInput
                        value={newResetPin}
                        inputType="tel"
                        onChange={setNewResetPin}
                        numInputs={4}
                        shouldAutoFocus={true}
                        containerStyle="flex w-full justify-between md:justify-start md:gap-[30px] lg:gap-[50px] text-sm leading-[18px] lg:leading-[20.8px] lg:text-[20px]"
                        inputStyle={{
                          color: isDarkMode ? "#ffffff" : "#403f3f",
                          width: 40,
                          height: 40,
                          borderRadius: 3,
                          backgroundColor: isDarkMode ? "black" : "white",
                          border: isDarkMode
                            ? "1px solid white"
                            : "1px solid #ccc",
                          ...(window.innerWidth >= 768 &&
                            window.innerWidth < 1024 && {
                              width: "40px",
                              height: "40px",
                            }),
                          ...(window.innerWidth >= 1024 && {
                            width: "65px",
                            height: "65px",
                          }),
                          //   marginRight: "4px",
                        }}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="inputOTP text-base leading-[18px] lg:leading-[20.8px] lg:text-[20px] mx-[3px]"
                          />
                        )}
                        isInputNum
                      />
                    </div>
                  </div>

                  <div className="mt-[10%] lg:mt-[5%]">
                    <h2 className={`text-[12px] text-[#7E7E7E] font-semibold md:text-[14px] lg:text-[18px] ${isDarkMode ? "text-white" : ""}`}>
                      Confirm PIN
                    </h2>
                    <div className="mt-[3%]">
                      <OtpInput
                        id="confirmResetPinInput"
                        value={confirmResetPin}
                        inputType="tel"
                        onChange={setConfirmResetPin}
                        numInputs={4}
                        shouldAutoFocus={true}
                        containerStyle="flex w-full justify-between md:justify-start md:gap-[30px] lg:gap-[50px]"
                        inputStyle={{
                          color: isDarkMode ? "#ffffff" : "#403f3f",
                          width: 40,
                          height: 40,
                          borderRadius: 3,
                          backgroundColor: isDarkMode ? "black" : confirmPinInputBgColor,
                          border: isDarkMode
                            ? "1px solid white"
                            : "1px solid #ccc",
                          ...(window.innerWidth >= 768 &&
                            window.innerWidth < 1024 && {
                              width: "40px",
                              height: "40px",
                            }),
                          ...(window.innerWidth >= 1024 && {
                            width: "65px",
                            height: "65px",
                          }),
                          //   marginRight: "4px",
                        }}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="inputOTP text-[12px] md:text-[14px] lg:text-[20px] mx-[3px]"
                          />
                        )}
                        isInputNum
                      />
                      {errorCreateNewPin.length > 1 && (
                        <p className= {`text-red-500 text-start text-[12px] mt-[10px] ${errorCreateNewPin === "Pin Okay" ? "text-green-700" : "text-red-700"}`}>
                           {errorCreateNewPin}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="py-[30px] lg:py-[60px]">
                    <button
                      className={`${
                        newResetPin.length !== 4 || confirmResetPin.length !== 4
                          ? "bg-[#63616188] cursor-not-allowed"
                          : "bg-primary"
                      } w-full md:w-fit text-white rounded-md px-[28px] text-[12px] md:px-[30px] md:py-[10px] md:text-[13px] md:font-[600] leading-[15px] lg:text-[16px] lg:px-[60px] lg:py-[15px] 2xl:text-[20px] 2xl:px-[50px] 2xl:py-[10px] lg:leading-[24px] py-[15px]
        `}
                      onClick={() => {
                        handleCreatePin();
                      }}
                      disabled={
                        newResetPin.length !== 4 || confirmResetPin.length !== 4
                      }
                    >
                      Create
                    </button>
                  </div>
                </section>
              </div>
            )}

            {createPin && (
              <Modal className="">
                <div
                  className={` ${
                    toggleSideBar ? "absolute overflow-scroll w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] md:ml-[20%] h-auto  lg:h-[405px] shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)] top-[0%]" : " absolute w-[90%] md:w-[45%] lg:w-[40%] md:h-[350px] h-[250px] lg:h-[405px]  shrink-0 rounded-[8px] shadow-[0px_0px_7.068181991577148px_0px_rgba(0,0,0,0.25)]"
                  } flex flex-col justify-between items-center pb-[10px] md:pb-[30px] lg:pb-[30px] md:mx-auto md:my-auto lg:mx-auto lg:my-auto rounded-[12px] ${isDarkMode ? "bg-stone-950 border-white border": "bg-white"}`}
                >
                  <div className="absolute z-0 right-0" style={{ zIndex: 0 }}>
                    <img
                      src={PopUpGreen}
                      alt=""
                      className="md:hidden rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenTab}
                      alt=""
                      className="hidden md:block rounded-tr-[10px]"
                    />
                    <img
                      src={PopUpGreenDeskTop}
                      alt=""
                      className="hidden rounded-tr-[20px]"
                    />
                  </div>

                  <div className="relative z-10">
                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[8%] lg:mt-[3%] z-[1000] ${styles.overlayText} `}
                    >
                      Successful
                    </p>

                    <p
                      className={`text-[12px] px-[20px] md:text-[16px] lg:text-[18px] font-semibold text-center mt-[4%] lg:my-[%] z-[1000] ${styles.overlayText}`}
                    >
                      You have successfully changed your transaction PIN.
                    </p>
                  </div>

                  <img src={Success} alt="" className="h-[50%] md:h-[40%]" />

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setNewResetPin("");
                      setConfirmPin("");
                      setConfirmResetPin("");
                      setResetPin(true);
                      handleClick(activeIndex);
                      setCreatePin(false);
                      setResetPin1(false);
                    }}
                    className={`my-[%] mt-0  bg-[#04177f] w-[90%] flex justify-center py-[16px] items-center mx-auto cursor-pointer text-[12px] font-extrabold h-[40px] text-white rounded-[6px] md:w-[40%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
                  >
                    Done
                  </button>
                </div>
              </Modal>
            )}

            {changePassword && <ChangePassword></ChangePassword>}
          </section>

          {/* <div
            className={`${
              isDarkMode ? "" : ""
            } flex gap-[15px] justify-center items-center  pb-[25%] md:pb-[10%] md:mt-[100%] lg:mt-[100%] lg:pb-0`}
          >
            <div className="text-[10px] md:text-[12px] lg:text-[14px]">
              You need help ?
            </div>
            <Link to="/ContactUs">
              <div
                className={`${
                  isDarkMode ? "border" : "bg-[#04177f]"
                } text-[10px] p-1 text-white rounded-[8px] lg:text-[18px]`}
              >
                Contact Us
              </div>
            </Link>
          </div> */}
        </div>
      )}
      {loading && (
        <Modal>
          <Loader/>
        </Modal>
      )}
     
     
    </div>
  );
};

export default ChangePin;
